/* eslint-disable react-hooks/exhaustive-deps */
import {Button, Container, Grid} from "@mui/material";
import {apiGetAccountingTypes} from "api/accountingTypeApi";
import {apiGetGrosProfit, apiSetFiscalYear} from "api/fiscalYearApi";
import {apiGetShareholders} from "api/shareholderApi";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import Table from "components/Table2";
import Percent from "components/Table2/CellComps/Percent";
import Price from "components/Table2/CellComps/Price";
import Text from "components/Table2/CellComps/Text";
import {DateToString} from "components/Reports/DateFilter";
import BasicSelect from "components/BasicInputs/BasicSelect";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import Header from "./Header";
import InfoBox from "./InfoBox";
import PercentPriceInput from "./PercentPriceInput";
import PriceFormat from "./PriceFormat";
import {apiGetWarehouses} from "api/warehouseApi";
import PageHeader from "components/Shared/PageHeader";
import useResponsive from "helpers/useResponsive";
import BasicDateInput from "components/BasicInputs/BasicDateInput";

export default function CloseFiscalYear() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {isMobile} = useResponsive();
    const store = useSelector((state: any) => state);
    const {token} = store.businessReducer.business;
    const {shareholders} = store.shareholderReducer;
    const {warehouses} = store.warehouseReducer;
    const [closeDate, setCloseDate] = useState(DateToString(Date.now()));
    const [startDate, setStartDate] = useState(DateToString(Date.now()));
    // const [endDate, setEndDate] = useState(DateToString(new Date(new Date().setFullYear(new Date().getFullYear() + 1))));
    const [endDate, setEndDate] = useState(DateToString(Date.now()));
    const [grosProfit, setGrosProfit] = useState(0);
    const [isLoss, setIsLoss] = useState(false);
    const [profitPercentage, setProfitPercentage] = useState(0);
    const [taxPercentage, setTaxPercentage] = useState(0);
    const [netProfit, setNetProfit] = useState<number>(grosProfit);
    const [shareProfit, setShareProfit] = useState<number>(netProfit);
    const [currency, setCurrency] = useState("ريال");
    const [accountTypes, setAccountTypes] = useState<any>({});
    const [accountType, setAccountType] = useState<any>();
    const [warehouseId, setWarehouseId] = useState<any>();
    const [title, setTitle] = useState<string | number>("");
    const profitLabel = isLoss ? "زیان" : "سود";
    const profitColor = isLoss ? "#F42222" : "#1E8E1B";

    function normalizeShareHolders(data?: any[]) {
        if (!data || !Array.isArray(data)) return [];
        const rightData = data.filter((x) => x.Person && x.Person.nickName);
        if (rightData.length === 0) return [];
        const res = data.map((x) => ({
            title: x.Person.nickName,
            percent: x.percent,
            profit: (shareProfit * x.percent) / 100,
        }));
        return res;
    }

    useEffect(() => {
        // @ts-ignore
        dispatch(apiGetShareholders(token));
        // dispatch(apiGetWarehouses(token));
        // dispatch(
        //   apiGetAccountingTypes(token, "all", (data: any) => {
        //     const res = {
        //       title: data.title,
        //       id: "main",
        //       childs: data.childs.map((x: any) => ({ ...x, parentId: "main" })),
        //     };
        //     setAccountTypes(res);
        //   })
        // );
        dispatch(
            // @ts-ignore
            apiGetGrosProfit(token, (response: any) => {
                const val = response.data.profitAndLoss.profit;
                setGrosProfit(Math.abs(val));
                setNetProfit(Math.abs(val));
                setIsLoss(val < 0);
            })
        );
    }, [token]);

    function handleSubmit() {
        const data = {
            profitPercentage,
            taxPercentage,
            fiscalYearTitle: title,
            startDate,
            endDate,
            accountTypeId: accountType?.id,
            warehouseId,
        };

    function callback(res: any) {}

        // @ts-ignore
        dispatch(apiSetFiscalYear(token, data, callback));
    }

    return (
        <Container maxWidth="lg">
            <PageHeader
                heading={`بستن سال مالی منتهی به ${closeDate}`}
                subHeading="عملیات بستن حساب های سال مالی"
            />
            <Grid container>
                <Grid item md={8} xs={12} style={{padding: "10px"}}>
                    <div style={{backgroundColor: "#ffffff", borderRadius: "10px"}}>
                        <Header withDivider>
                            <span style={{color: profitColor}}>{profitLabel + " خالص"}</span>
                            <PriceFormat value={grosProfit} currency={currency}/>
                        </Header>

                        {!isLoss && (
                            <>
                                <div style={{padding: 24}}>
                                    <InfoBox heading="مالیات بر درآمد">
                                        <PercentPriceInput
                                            totalPrice={grosProfit}
                                            onChange={(x) => {
                                                setNetProfit(grosProfit - x.price);
                                                setTaxPercentage(x.percent);
                                            }}
                                        />
                                    </InfoBox>
                                </div>
                                <Header>
                                    <span style={{color: "#1E8E1B"}}>سود خالص پس از کسر مالیات</span>
                                    <PriceFormat value={netProfit} currency={currency}/>
                                </Header>
                            </>
                        )}
                        <div style={{padding: 24}}>
                            <InfoBox heading={"تقسیم " + profitLabel}>
                                <div className="flex justify-between items-end flex-wrap">
                                    <PercentPriceInput
                                        totalPrice={netProfit}
                                        onChange={(x) => {
                                            setShareProfit(x.price);
                                            setProfitPercentage(x.percent);
                                        }}
                                    />
                                    <div className="p-2 pt-6 w-full md:w-auto">
                                        <BasicSelect
                                            withRefresh
                                            refreshList={() => {
                                                dispatch(
                                                    // @ts-ignore
                                                    apiGetAccountingTypes(token, "all", (data: any) => {
                                                        const res = {
                                                            title: data.title,
                                                            id: "main",
                                                            childs: data.childs.map((x: any) => ({
                                                                ...x,
                                                                parentId: "main"
                                                            })),
                                                        };
                                                        setAccountTypes(res);
                                                    })
                                                );
                                            }}
                                            options={accountTypes || []}
                                            label="حساب"
                                            isNested
                                            onChange={(item) => setAccountType(item)}
                                            defaultValue={accountType?.title}
                                            menuStyle={{minWidth: isMobile ? 360 : 420}}
                                            containerStyle={{width: isMobile ? "100%" : "auto"}}
                                        />
                                    </div>
                                </div>
                            </InfoBox>
                        </div>
                        <div style={{padding: 24}}>
                            <Table
                                key={shareProfit}
                                headers={[{label: "سهامدار"}, {label: profitLabel}, {label: "درصد"}]}
                                cols={[
                                    {Comp: Text, key: "title"},
                                    {Comp: Price, key: "profit"},
                                    {Comp: Percent, key: "percent"},
                                ]}
                                rows={normalizeShareHolders(shareholders)}
                                withoutMenu
                                headerColor="transparent"
                            />
                        </div>
                    </div>
                    <div className="bg-white rounded-lg my-8">
                        <Header withDivider>
                            <span>شروع سال مالی جدید</span>
                        </Header>
                        <div style={{padding: 24}}>
                            <div
                                className="flex justify-between items-end w-full flex-wrap gap-y-4 mb-6 whitespace-nowrap">
                                <BasicTextInput
                                    label="عنوان سال مالی*"
                                    style={{minWidth: 300}}
                                    val={title}
                                    onChange={(val) => setTitle(val)}
                                />
                                <div className="flex justify-end gap-2 items-end pr-3 h-full w-full md:w-auto">
                                    <BasicDateInput
                                        label="تاریخ شروع*"
                                        onChange={(dates) => dates && setStartDate(dates[0])}
                                        defaultValues={[startDate]}
                                        styles={{inputWrapper: {minWidth: "120px"}}}
                                        withoutClear
                                    />
                                    <BasicDateInput
                                        label="تاریخ پایان*"
                                        onChange={(dates) => dates && setEndDate(dates[0])}
                                        defaultValues={[endDate]}
                                        styles={{inputWrapper: {minWidth: "120px"}}}
                                        withoutClear
                                    />
                                </div>
                            </div>
                            <InfoBox heading="جمع بندی موجودی انبار ها">
                                <div style={{display: "flex", marginTop: 24}}>
                                    <BasicSelect
                                        withRefresh
                                        refreshList={() => {
                                            // @ts-ignore
                                            dispatch(apiGetWarehouses(token));
                                        }}
                                        options={warehouses}
                                        label="انبار مقصد*"
                                        style={{minWidth: isMobile ? 250 : 300, width: isMobile ? "100%" : "auto"}}
                                        onChange={(val) => setWarehouseId(val)}
                                    />
                                </div>
                            </InfoBox>
                        </div>
                    </div>
                </Grid>
                <Grid item md={4} xs={12} style={{padding: "10px"}}>
                    <div style={{backgroundColor: "#ffffff", borderRadius: 12, padding: 16}}>
                        <Header>
                            <span>خلاصه سال مالی</span>
                        </Header>
                        <div style={{backgroundColor: "#F9FAFE", borderRadius: 8}}>
                            <Header>
                                <span style={{color: profitColor}}>{profitLabel + " خالص"}</span>
                                <PriceFormat value={grosProfit} currency={currency}/>
                            </Header>
                            <Header>
                <span style={{color: "#576271", fontSize: 14}}>
                  {profitLabel + " تقسیم شده بین سهامداران"}
                </span>
                                <PriceFormat value={shareProfit} currency={currency}/>
                            </Header>
                            <Header>
                                <span
                                    style={{color: "#576271", fontSize: 14}}>{profitLabel + " انباشته (سنواتی)"}</span>
                                <PriceFormat value={netProfit - shareProfit} currency={currency}/>
                            </Header>
                            <Header>
                                <span>سال مالی جدید</span>
                            </Header>
                            <div style={{display: "flex", justifyContent: "center"}}>
                                {/*<DateBox label="شروع:" value={startDate} />*/}
                                {/*<DateBox label="پایان:" value={endDate} />*/}
                            </div>
                        </div>
                        <Button
                            variant="contained"
                            color="primary"
                            style={{marginTop: 18}}
                            fullWidth
                            onClick={handleSubmit}
                        >
                            بستن سال مالی
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Container>
    );
}
